import { styled } from "@mui/material";

export const SelectorDiv = styled("div", {
  shouldForwardProp: prop => prop !== "isSelected" && prop !== "disabled",
})<{ isSelected: boolean; disabled?: boolean }>(({ theme, isSelected, disabled }) => ({
  width: 45,
  height: 25,
  backgroundColor: isSelected ? theme.palette.primary.main : theme.palette.divider,
  borderRadius: 25,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingLeft: isSelected ? 20 : 0,
  transition: "all 0.1s linear",
  boxSizing: "border-box",
  cursor: disabled ? "auto" : "pointer",
}));

export const WhiteCircle = styled("div")(({ theme }) => ({
  height: 23,
  width: 23,
  borderRadius: "50%",
  backgroundColor: theme.palette.grey[500],
  marginLeft: 1,
  marginRight: 1,
}));

export const WhiteCircleSmall = styled("div")(({ theme }) => ({
  height: 10,
  width: 10,
  borderRadius: "50%",
  backgroundColor: theme.palette.grey[500],
  marginLeft: 2,
  marginRight: 2,
}));

export const SelectorDivSmall = styled("div", {
  shouldForwardProp: prop => prop !== "isSelected" && prop !== "disabled",
})<{ isSelected: boolean; disabled?: boolean }>(({ theme, isSelected, disabled }) => ({
  width: 26,
  height: 14,
  backgroundColor: isSelected ? theme.palette.primary.main : theme.palette.divider,
  borderRadius: 25,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingLeft: isSelected ? 12 : 0,
  transition: "all 0.1s linear",
  boxSizing: "border-box",
  cursor: disabled ? "auto" : "pointer",
}));

export const Wrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const Label = styled("div")(() => ({
  padding: "0 5px",
  fontSize: 10,
}));
